// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"e2ea846a","367":"819ac2d1","628":"ab668cac","787":"2d434f7b","863":"aeaf5f3b","964":"ced54e52","985":"fc13bb5d"}[chunkId] + ".chunk.js";
};